import React from 'react'
import { QuestionCard, CircularProgress } from '../../shared'
import { ReactComponent as IconCorrect } from '../../shared/assets/cup_correct.svg'
import { ReactComponent as IconWrong } from '../../shared/assets/cup_wrong.svg'
import styles from './Summary.module.css'

const Summary = props => (
  <div className={styles.base}>
    <div className={styles.header}>
      <div>
        {props.progress.passed &&
          <div className={styles.card}>
            <props.passedComponent {...props} />

            {/* <div className={styles.icon}>
              <IconCorrect />
            </div> */}
          </div>
        }
        {!props.progress.passed &&
          <div className={styles.card}>
            <props.notPassedComponent {...props} />

            {/* <div className={styles.icon}>
              <IconWrong />
            </div> */}
          </div>
        }
      </div>
      <div>
        <div className={styles.progress}>
          <CircularProgress
            sqSize={216}
            strokeWidth={10}
            current={props.progress.currentScore}
            total={props.progress.totalPoints}
            percentage={props.progress.currentScore / props.progress.totalPoints * 100} />

          <div className={styles.progressText}>Jouw score op de eindtoets</div>
        </div>
      </div>
    </div>
    <div className={styles.content}>
      {props.questions.map((question, idx) => (
        <QuestionCard key={question.id}
          simple
          prefix={`${idx + 1}. `}
          quiz={props.quiz}
          question={question}
          progress={question.progress}
          answers={question.answers}
          onUpdate={() => { }}
          submitQuestion={() => { }} />
      ))}
    </div>
  </div>
)

export default Summary
